export const BrandColors = {
  primary: '#285FCB',
  alert: '#FF6060',
};
